import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

// Global dayjs plugins, loaded once from index.js.
// customParseFormat: dayjs(value, 'YYYY-MM-DD') format args (DatePicker fields).
// relativeTime: .fromNow() (user last-login, SKU sync age).
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
